const comMain = (() => {
  if (document.querySelector("section#jsComSecMain") !== null) {



    let secMain = document.querySelector('#jsComSecMain');
    let imgBox = secMain.querySelector('.js-img-box');
    let videos = imgBox.querySelectorAll('video');
    let copyBox = secMain.querySelector('.js-copy-box');


    // {
    //   let to = gsap.to(imgBox, {
    //     y: 200,
    //     ease: "none",
    //     scrollTrigger: {
    //       trigger: secMain,
    //       start: 'top top',
    //       end: 'bottom top',
    //       scrub: 0,
    //       // markers: true
    //     }
    //   })

    //   let target = document.querySelector('body');
    //   let observer = new ResizeObserver((entries) => {
    //     entries.forEach((entry) => {
    //       to.scrollTrigger.refresh()
    //       // console.log('comParallax refresh');
    //     });
    //   });
    //   observer.observe(target);
    // }


    window.addEventListener('load', () => {

      if (videos.length > 0) {
        videos.forEach(element => {
          element.play()
        });
      }

      setTimeout(() => {
        imgBox.classList.add('is-act')
      }, 200);

      setTimeout(() => {
        copyBox.classList.add('is-act')
      }, 2500);

    })






  }
})()
export default comMain;